import { IRequestEventPdfFailure } from '../../../actions/events/fetchEventPdf'
import { IEventsStore } from '../index'

export default function(
  state: IEventsStore,
  action: IRequestEventPdfFailure,
): IEventsStore {
  return {
    ...state,
    pdfRequest: {
      ...state.pdfRequest,
      errMessage: action.errMessage,
      isLoading: false,
    },
  }
}
